module.exports = __webpack_public_path__ + "media/flags/mc-ba857e61.svg";